exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-btn[data-v-0916d70f] {\n  color: #fff !important;\n}\n.single-option[data-v-0916d70f] {\n  height: auto !important;\n}\n.justify-center[data-v-0916d70f] {\n  justify-content: center;\n}\n.product-warning-container[data-v-0916d70f] {\n  margin: 2rem 0;\n  border-top: 1px solid #d8d8d8;\n  border-bottom: 1px solid #d8d8d8;\n  padding: 0.5rem;\n}\n.product-warning-container summary[data-v-0916d70f] {\n  padding: 1rem;\n  font-weight: 800;\n  font-size: 1.8rem;\n}\n.product-warning-text[data-v-0916d70f] {\n  margin: 0.5rem;\n}", ""]);

// exports
